<template>
  <div>
    <div class="top">
        <div class="item-block">
          <div class="item-title">需参与人员总数</div>
          <div class="item-content">
            <span class="content-left" >
              <span class="num">{{formData.total_participants}}</span><span>人</span>
            </span>
            <span class="content-right" >
             <img src="@/assets/img/stu1.png" style="width: 35px;vertical-align: bottom"/>
            </span>
          </div>
        </div>
        <div class="item-block">
          <div class="item-title">已完成人员总数</div>
          <div class="item-content">
            <span class="content-left">
              <span class="num">{{formData.completed}}</span><span>人</span>
            </span>
            <span class="content-right">
              <img src="@/assets/img/stu2.png"  style="width: 38px;vertical-align: bottom"/>
            </span>
          </div>
        </div>
        <div class="item-block">
          <div class="item-title">未开始人员总数</div>
          <div class="item-content">
            <span class="content-left">
              <span class="num" >{{formData.not_started}}</span><span>人</span>
            </span>
            <span class="content-right">
              <img src="@/assets/img/stu3.png"  style="width: 42px;margin-top:-4px;" />
            </span>
          </div>
        </div>
        <div class="item-block">
          <div class="item-title">学习中人员总数</div>
          <div class="item-content">
            <span class="content-left">
              <span class="num">{{formData.in_progress}}</span><span>人</span>
            </span>
            <span class="content-right" style="line-height: 26px;">
               <img src="@/assets/img/stu4.png"  style="width: 30px;" />
            </span>
          </div>
        </div>
    </div>
    <div class="bottom">
      <el-table :data="tableData" stripe max-height="400">
        <el-table-column label="参与人员" min-width="100" prop="username" align="center"></el-table-column>
        <el-table-column label="学习进度" min-width="150" header-align="center">
          <template v-slot="{row}">
            <el-progress :percentage="row.training_progress" :color="row.training_progress ===100 ? '#81B337' : row.training_progress === 0 ? '#E34D59' : '#FFBF6B'"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="完成情况" min-width="80" prop="status" align="center">
          <template v-slot="{row}">
            <span v-if="row.status === '已完成'" style="color:#81B337">已完成</span>
            <span v-if="row.status === '未开始'" style="color:#E34D59">未开始</span>
            <span v-if="row.status === '学习中'" style="color:#FFBF6B">学习中</span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" min-width="100" prop="complete_time" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {getParticipantsDtl, getTrainingDtl} from "@/api/training";

  export default {
    name: "ellectDialog",
    props: {
      dtlId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        formData: {},
        tableData: []
      }
    },
    created() {
      this.getData()
    },
    watch: {
      dtlId(val) {
        this.getData()
      }
    },
    methods: {
      getData(){
        if(this.dtlId){
          getParticipantsDtl({training_id:this.dtlId,page_size:300}).then(res => {
            this.formData = res.data
            this.tableData = res.data.participants
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.top{
  display: flex;
  justify-content: space-between;
  .item-block{
    width: 23%;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    padding:13px 20px 10px 20px;
    margin-right: 16px;
    .item-title{
      display: block;
      font-size: 20px;
      margin-bottom: 18px;
    }
    .item-content{
      display: inline-block;
      width: 100%;
      height: 35px;
      vertical-align: bottom;
      .content-left{
        width: 20%;
        vertical-align: bottom;
        span{
          display: inline-block;
          vertical-align: bottom;
        }
      }
      .content-right{
        display: inline-block;
        width: 80%;
        text-align: right;
       line-height: 35px;
      }
      span{
        display: inline-block;
        font-size: 14px;
        height: 100%;
        vertical-align: bottom;
        span{
          line-height: 35px;
        }
      }
      span.num{
        font-size: 20px;
        margin-right: 8px;
        line-height: 35px;
      }
    }
  }
}
::v-deep .el-progress-bar {
  padding-right: 60px;
  margin-right: -60px;
}
</style>